// 新版个股页面、社区使用的时间格式
export function addZeroBeforeTime(num) {
  num = num >= 10 ? num : '0' + num;
  return num;
}

// ctime:传进来的时间戳
export function formatTime(ctime = new Date().getTime()) {
  if (ctime <= 0) {
    return `刚刚`;
  }
  if (String(ctime).length !== 10 && String(ctime).length !== 13) {
    return `刚刚`;
  }
  if (String(ctime).length === 10) {
    ctime = ctime * 1000;
  }
  const now = new Date();
  const diffValue = now - ctime;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = addZeroBeforeTime(currentDate.getMonth() + 1);
  const currentDay = addZeroBeforeTime(currentDate.getDate());
  const date = new Date(ctime);
  const year = date.getFullYear();
  const month = addZeroBeforeTime(date.getMonth() + 1);
  const day = addZeroBeforeTime(date.getDate());
  const hour = addZeroBeforeTime(date.getHours());
  const minutes = addZeroBeforeTime(date.getMinutes());
  if (currentYear === year) {
    if (currentMonth === month && currentDay === day) {
      if (diffValue < 60000) {
        return `刚刚`;
      } else if (diffValue / 60000 < 60) {
        return `${Math.floor(diffValue / 60000)} 分钟前`;
      } else if (diffValue / (60000 * 60) < 24) {
        return `${Math.floor(diffValue / (60000 * 60))} 小时前`;
      }
    } else if (currentMonth === month && currentDate.getDate() === date.getDate() + 1) {
      return `昨日 ${hour}:${minutes}`;
    } else {
      return `${month}-${day}`;
    }
  } else {
    return `${year}-${month}-${day}`;
  }
}

// 新版个股页面、社区使用的数字格式化
export function formatNum(num) {
  if (num < 0) {
    return 0;
  } else if (num < 10000) {
    return num;
  } else if (num >= 10000 && num < 100000) {
    return `${(num / 10000).toFixed(1)}w`;
  } else if (num >= 100000 && num < 990000) {
    return `${(num / 10000).toFixed(0)}w`;
  } else if (num >= 990000) {
    return `99w+`;
  } else {
    return 0;
  }
}

export function stopBodyScroll() {
  const bodyEl = document.body;
  if (window.getPlatform() == 'gphone' && window.getOS().android < 4.3) {
    return;
  }
  if (bodyEl.style.position !== 'fixed') {
    const hxmScroll = window.scrollY;
    sessionStorage.setItem('hxmScrollY', hxmScroll);
    bodyEl.style.position = 'fixed';
    bodyEl.style.top = -hxmScroll + 'px';
  } else {
    bodyEl.style.position = 'static';
    bodyEl.style.top = '';
    window.scrollTo(0, sessionStorage.getItem('hxmScrollY')); // 回到原先的top
  }
}

//获取客户端用户的交易信息
export function getAccount() {
  return new Promise((resolve, reject) => {
    const THREETHOUNSAND = 3000;
    const timer = setTimeout(() => {
      reject();
    }, THREETHOUNSAND);
    window.callNativeHandler('getHkUsLoginAccount', {}, function (data) {
      clearTimeout(timer);
      resolve(data);
    });
  })
}

export function ajax(type, url, data) {
  return new Promise((resolve, reject) => {
    window.$.ajax({
      url,
      data,
      type,
      timeout: 3000,
      success: res => {
        resolve(res)
      },
      error: err => {
        reject(err)
      }
    });
  })
}

/**
 * 处理股票名称过长问题
 * @param name 股票名 
 * @returns 
 */
export function handleStockName(name) {
  if (name.length > 8) return `${name.slice(0,7)}...`;
  return name;
}

/**
 * 新股跳转版本判断
 * @returns string
 */
export function jumpIpoVersion(){
  if(window.getPlatform()==='gphone'){
    const androidNew = 104700;
    if(window.getAppVersion().replace(/\./g, '') >= androidNew) {
      return 'android_newVersion';
    }else{
      return 'android_oldVersion';
    }
  }else{
    const iosNew = 109090;
    if(window.getAppVersion().replace(/\./g, '') >= iosNew) {
      return 'ios_newVersion';
    }else{
      return 'ios_oldVersion';
    }
  }
}
/**
 * 灰度测试获取用户信息
 * @returns bollean 开启灰度开关
 */
export function openTest () {
  const promise = new Promise(resolve=>{
    let changer = false;
    callNativeHandler('getUserInfo',{},data=>{
      let tesmpData;
      if(data){
        tesmpData = typeof(data) === 'string' ? Number(String(JSON.parse(data).mobile).slice(-1)) : Number(String(data.mobile).slice(-1));
      }
      const separate = 2;
      if(data && (tesmpData % separate === 1) ){
        changer = true;
      }
      resolve(changer);
    });
  });
  return promise;
}

/**
 * 新股跳转执行
 * @param param  HKUSTradeLoginModeJump协议所需参数
 * @param disLogin  是否未登录
 * @returns HKUSTradeLoginModeJump协议所需参数
 */
export function jumpIpoAction (param,disLogin) {
  const version = jumpIpoVersion();
  param = param || {};
  let defaultUrl;
  if (window.getPlatform() === 'iphone') {
    defaultUrl = `client.html?action=ymtz^webid=2901`;
  } else {
    defaultUrl = `client.html?action=ymtz^webid=21600`;
  }
  const newParam = Object.keys(param).length === 0 ? {} :  {
    qsId:param.qsId,
    wtId:param.wtId,
    account:param.account,
    jumpInfo:{
      jumpUrl:param.url ? `client.html?action=ymtz^webid=2804^url=${param.url}?marketId=${param.marketId}&stockCode=${param.stockCode}&fromPage=true` : defaultUrl,
      resourcesId:'xgsg',
    },
  };
  const newJump = () => {
    if(disLogin === true && getPlatform() === 'gphone' && newParam.jumpInfo.jumpUrl.indexOf('21600') > -1 ){
      //当前版本安卓客户端在未登录券商情况下使用HKUSTradeLoginModeJump协议跳转21600会造成app卡死，需前端做容错
      newParam.jumpInfo.jumpUrl = '';
      window.callNativeHandler('HKUSTradeLoginModeJump', newParam , ()=>{});
    }else{
      window.callNativeHandler('HKUSTradeLoginModeJump', newParam, ()=>{});
    }
  };
  const oldJump = () => {
    window.location.href = `client.html?action=ymtz^webid=2804^url=${param.url}?marketId=${param.marketId}&stockCode=${param.stockCode}&fromPage=true`;
  };
  const checkVersion = {
    android_newVersion:newJump,
    android_oldVersion:oldJump,
    ios_newVersion:newJump,
    ios_oldVersion:oldJump,
  };
  checkVersion[version] && checkVersion[version]();
}
